var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "step",
    {
      attrs: {
        title: _vm.title,
        id: "import-enriched-data",
        description: _vm.description,
        component: _vm.component,
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-grow flex flex-col pb-4" },
        [
          _c(
            "toolbar",
            [
              _c(
                "field",
                {
                  staticClass: "mr-4 flex-grow",
                  attrs: {
                    inline: "",
                    label: "Version Name",
                    disabled: _vm.scratchPadNode.length === 0,
                  },
                },
                [
                  _c("text-field", {
                    model: {
                      value: _vm.innerValue,
                      callback: function ($$v) {
                        _vm.innerValue = $$v
                      },
                      expression: "innerValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "btn",
                {
                  staticClass: "my-2",
                  attrs: {
                    disabled:
                      _vm.isImportDisabled || _vm.scratchPadNode.length === 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.importData()
                    },
                  },
                },
                [_vm._v("Import Data")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "details-wrapper" }, [
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "import-header pb-4" }, [
                  _vm._v("Enrichment Info"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "import-item" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Enrichment Path:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.enrichment !== null
                          ? _vm.enrichment.enrichmentPath
                          : "Skipped Enrichment"
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "import-header pb-4" }, [
                  _vm._v("Validation Info"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "import-item" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Validation Name:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.validation !== null
                          ? _vm.validation.description
                          : "Skipped Validation"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.existingLoanFound === false
            ? _c(
                "div",
                { key: "existing-loan-found", staticClass: "list-group" },
                [
                  _c("div", { staticClass: "count-wrapper" }, [
                    _c("div", { staticClass: "count-display" }, [
                      _vm._v("New Count: " + _vm._s(_vm.insertCount)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "count-display" }, [
                      _vm._v("Updated Count: " + _vm._s(_vm.updateCount)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "count-display" }, [
                      _vm._v("Withdrawn Count: " + _vm._s(_vm.deleteCount)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "blank-placeholder items-center justify-center text-xl text-amc-gray-800",
                    },
                    [
                      _vm._v(
                        "\n        Your data has been successfully imported.\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm.existingLoanFound === true
            ? _c(
                "div",
                { key: "duplicate-loan-found", staticClass: "list-group" },
                [
                  _c(
                    "div",
                    { staticClass: "flex w-full" },
                    [
                      _c("div", { staticClass: "count-display" }, [
                        _vm._v("Errors Occurred During Import..."),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-grow" }),
                      _vm._v(" "),
                      _c("action", {
                        staticClass: "mr-4",
                        attrs: { icon: "mdi mdi-microsoft-excel" },
                        on: {
                          click: function ($event) {
                            return _vm.exportErrorData()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "splitter",
                    { staticClass: "flex-grow", attrs: { panes: _vm.panes } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col h-full" },
                        [
                          _c(
                            "grid",
                            {
                              key: _vm.errorGridKey,
                              ref: "errorGrid",
                              staticClass: "grow",
                              attrs: {
                                "row-data": _vm.errorMessages,
                                "floating-filter": false,
                                "get-row-id": _vm.getRowId,
                                "get-context-menu-items": _vm.contextMenuItems,
                              },
                              on: {
                                "selection-changed": function ($event) {
                                  return _vm.onErrorMessageSelected($event)
                                },
                              },
                            },
                            [
                              _c("grid-column", {
                                attrs: {
                                  field: "key",
                                  "header-name": "Message",
                                  "min-width": 80,
                                  flex: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col h-full" },
                        [
                          _c(
                            "grid",
                            {
                              key: _vm.selectedErrorGridKey,
                              staticClass: "grow",
                              attrs: {
                                "row-data": _vm.selectedErrorMessages,
                                "floating-filter": false,
                                "get-context-menu-items": _vm.contextMenuItems,
                              },
                            },
                            [
                              _c("grid-column", {
                                attrs: {
                                  field: "errorDesc",
                                  "header-name": "Message",
                                  flex: 1,
                                },
                              }),
                              _vm._v(" "),
                              _c("grid-column", {
                                attrs: {
                                  field: "requiredLoanId",
                                  "header-name": "Loan Id",
                                  width: 160,
                                },
                              }),
                              _vm._v(" "),
                              _c("grid-column", {
                                attrs: {
                                  field: "internalFieldName",
                                  "header-name": "Internal Field",
                                  width: 200,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c("div", { key: "no-results", staticClass: "list-group" }, [
                _vm.scratchPadNode.length > 0
                  ? _c("div", { staticClass: "blank-placeholder" })
                  : _c(
                      "div",
                      {
                        staticClass:
                          "blank-placeholder items-center justify-center text-xl text-amc-gray-800",
                      },
                      [
                        _vm._v(
                          "\n        No Enrichment data can be imported since enrichment was skipped\n      "
                        ),
                      ]
                    ),
              ]),
          _vm._v(" "),
          _vm.existingLoanFound !== null
            ? _c("div", { staticClass: "next-actions" }, [
                _c("div", { staticClass: "title" }, [_vm._v("Next you can")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _vm.existingLoanFound === true
                      ? _c("flash-card", {
                          staticClass: "mr-8",
                          attrs: {
                            red: "",
                            title: "Adjust errors",
                            "water-icon": "mdi mdi-alert-circle",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("flash-card", {
                      staticClass: "mr-8 cursor-pointer",
                      attrs: {
                        title: "Begin a new import",
                        "water-icon": "mdi mdi-arrow-left-bold-circle",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.restart()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("flash-card", {
                      staticClass: "mr-8",
                      attrs: {
                        title: "Modify this version",
                        description:
                          "Use the step process at the top of the page to go back, make adjustments, and save a new version.",
                      },
                    }),
                    _vm._v(" "),
                    _c("flash-card", {
                      staticClass: "mr-8 cursor-pointer",
                      attrs: {
                        title: "Transaction Management",
                        description: "View the details of this package.",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.gotoTransaction()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }